import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorV2Component } from '../../base-template-editor-v2/field-editor-v2/field-editor-v2.component';
import { InlineEditV2Directive } from '../../base-template-editor-v2/inline-edit/inline-edit-v2.directive';

/**
 * Mockup-styled Preheader block - drop-in replacement for app-preheader,
 * covering both the center canvas (isPreview=true, see preview-v2 - typed
 * into directly via appInlineEdit) and the right-panel edit form
 * (isPreview=false, see edit-block-comments-v2). Both go through onChange.
 * See subject-v2 for the reasoning (app-field-editor-v2: plain inline box +
 * popout WYSIWYG modal, since Preheader is expected to carry formatting).
 */
@Component({
  selector: 'app-preheader-v2',
  imports: [CommonModule, FieldEditorV2Component, InlineEditV2Directive],
  templateUrl: './preheader-v2.component.html',
  styleUrl: './preheader-v2.component.scss',
  // Eager (= Default), not OnPush: block.variables.Preheader is mutated in
  // place (not reassigned), so an OnPush sibling (this component, in
  // preview-v2's isPreview=true instance) would never see the input as
  // "changed" and would go stale after editing in the right panel.
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PreheaderComponentV2 {
  @Input() block: any;
  @Input() isPreview = false;
  @Input() disabled = false;

  @Output() blockData = new EventEmitter<any>();

  protected readonly preheaderPlaceholder = 'Enter Preheader';

  protected onChange(value: string): void {
    if (this.block?.variables) {
      this.block.variables.Preheader = value;
      this.blockData.emit(this.block);
    }
  }
}
